@if (form.view) {
    @if (form.view) {
        <form class="w-100" (ngSubmit)="submit()">
            <!-- Row 1: Community, Staff, Service Type -->
            <sf-form
                name="row-1"
                (ngModelChange)="onModelChanged($event)"
                [view]="form.view"
                class="col-12"
                rowClasses="col-4"
                [(ngModel)]="form.model"
                [fields]="['community', 'staff', 'serviceType']"
            >
            </sf-form>
            <!-- Row 2: Scheduled Start, Scheduled End -->
            <sf-form
                name="row-2"
                (ngModelChange)="onModelChanged($event)"
                [view]="form.view"
                class="col-12"
                rowClasses="col-6"
                [(ngModel)]="form.model"
                [fields]="['scheduledStart', 'scheduledEnd']"
            >
            </sf-form>
            <!-- Repeat Days -->
            <sf-form
                name="row-3"
                (ngModelChange)="onModelChanged($event)"
                [view]="form.view"
                class="col-12"
                rowClasses="col-4"
                [(ngModel)]="form.model"
                [fields]="['repeatDays']"
            >
            </sf-form>
            <!-- Description and Photos -->
            <sf-form
                name="row-4"
                (ngModelChange)="onModelChanged($event)"
                [view]="form.view"
                class="col-12"
                rowClasses="col-12"
                [(ngModel)]="form.model"
                [fields]="['description', 'photos']"
            >
            </sf-form>
            <div class="pe-4">
                <button type="submit" class="flex-shrink-1 btn btn-success ms-auto d-flex align-items-center">
                    <i class="fa fa-fw fa-save mb-0 me-1"></i> Save
                </button>
                <hr />
            </div>
        </form>
    }
} @else {
    @if (form.error) {
        <small class="text-danger">Error loading form</small>
    } @else {
        <small class="text-muted">Loading...</small>
    }
}
